export const EVENT_ERROR_MESSAGES = {
  NOT_FOUND: 'Event not found',
  SERVER_ERROR: 'Error retrieving event',
};
